import React, { Component } from "react";
import { Row, Col, FormInput, FormGroup, FormSelect } from "shards-react";
import NumberFormat from "react-number-format";
import TimePicker from "rc-time-picker";
import "rc-time-picker/assets/index.css";
import { connect } from "react-redux";
import { httpClient } from "../../utils/HttpClient";
import * as actions from "../../actions/meeting.action";
import { getAllBuildings } from "../../actions/other_info/building.action";
import { getAllLocations } from "../../actions/other_info/location.action";
import { getAllRooms } from "../../actions/other_info/room.action";
import { getGroupName } from "../../actions/other_info/group_name.action";
import Swal from "sweetalert2";
import FileItem from "./FileItem";
import MeetingEvent from "./MeetingEvent";
import MeetingReportResponse from "./Report/MeetingReportResponse";
import { apiUrl, domainName } from "../../config/index";
import {
  Upload,
  message,
  Spin,
  Modal,
  Progress,
  Button,
  Select,
  Descriptions,
  Empty,
  Tabs,
  Input,
  Checkbox,
} from "antd";
import moment from "moment";
import MomentUtils from "@date-io/moment";
import {
  MuiPickersUtilsProvider,
  DatePicker,
} from "material-ui-thai-datepickers";
import "moment/locale/th";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Autosuggest from "react-autosuggest";
import {
  LoadingOutlined,
  UploadOutlined,
  CloseCircleFilled,
  DeleteOutlined,
} from "@ant-design/icons";

const filesize = require("filesize");
const { Option } = Select;
const { Dragger } = Upload;
const { TabPane } = Tabs;

class MeetingForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      meetings: [],
      meetingNameList: [],
      suggestions: [],
      buildings: [],
      locations: [],
      rooms: [],
      groupNames: [],
      attendees: [],
      commentGroups: [],
      comments: [],
      selectedComments: [],
      meetingName: "",
      commentName: "",
      year: "",
      email: {
        subject: "",
        body: "",
      },
      agendas: [
        {
          title: "เรื่องประธานแจ้งที่ประชุมทราบ",
          body: "",
          sequence: 1,
        },
        {
          title: "เรื่องเสนอที่ประชุมทราบ",
          body: "",
          sequence: 2,
        },
        {
          title: "เรื่องเสนอที่ประชุมพิจารณา",
          body: "",
          sequence: 3,
        },
        {
          title: "เรื่องอื่นๆ",
          body: "",
          sequence: 4,
        },
      ],
      updatedAgendas: [],
      inviteDocument: null,
      meetingDocument: null,
      finalDocument: null,
      reportDocument: null,
      reportFinalDocument: null,
      documentType: "",
      createDocumentMethod: 1,
      attendeesMethod: 1,
      isMeetingExist: false,
      attachments: [],
      templates: [],
      selectedTemplate: null,
      documentLoading: false,
      templateUploading: false,
      emailSending: false,
      startTime: 0,
      endTime: 0,
      folderId: "",
      file: "",
      password: "",
      fileUploadModalVisible: false,
      agendaDetailModalVisible: false,
      commentModalVisible: false,
      emailModalVisible: false,
      emailType: "",
      fileList: [],
      uploadFileMethod: 0,
      meetingDate: null,
      microsoftUsers: [],
      emailList: [],
      isAllEmailSent: true,
    };

    this.token = localStorage.getItem("token");

    this.uploadAgendaProps = {
      showUploadList: false,
      onRemove: (file) => {
        this.setState((state) => {
          const index = state.fileList.indexOf(file);
          const newFileList = state.fileList.slice();
          newFileList.splice(index, 1);
          return {
            fileList: newFileList,
          };
        });
      },
      beforeUpload: (file) => {
        if (
          file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        ) {
          this.setState((state) => ({
            inviteDocument: file,
          }));

          this.props.values.file = file;
        } else {
          message.error("สามารถอัพโหลดได้เฉพาะเอกสาร Microsoft Word เท่านั้น");
        }

        return false;
      },
    };

    this.handleStartTimeChange = this.handleStartTimeChange.bind(this);
    this.handleEndTimeChange = this.handleEndTimeChange.bind(this);
    this.onTemplateChange = this.onTemplateChange.bind(this);
    this.handleFileChanged = this.handleFileChanged.bind(this);
    this.handleEmailTagChange = this.handleEmailTagChange.bind(this);
  }

  async componentDidMount() {
    this.setState({ documentLoading: true });
    await this.props.getAllBuildings();
    await this.props.getAllLocations();
    await this.props.getAllRooms();
    await this.getMicrosoftAccount();
    await this.getMeetingName();

    if (this.props.values.id) {
      this.getComments();
      await this.props.getMeetingAttendees(this.props.values.id);
      await this.getMeetingDocuments(
        this.props.values.id,
        this.props.values.documentFolder
      );
    }

    await this.setState({
      folderId: this.props.values.documentFolder,
      buildings: this.props.buildingsReducer.buildings || [],
      locations: this.props.locationsReducer.locations || [],
      rooms: this.props.roomsReducer.rooms || [],
      groupNames: this.props.groupNamesReducer.groupNames || [],
      startTime: this.props.values.meetingStart || 0,
      endTime: this.props.values.meetingEnd || 0,
      documentLoading: false,
      meetingDate: this.props.values.meetingStart,
      password: this.props.values.password,
    });
  }

  async getMicrosoftAccount() {
    try {
      let response = await httpClient.get(`/api/users/microsoft/account`, {
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      });

      await this.setState({ microsoftAccounts: response.data });
    } catch (err) {}
  }

  async getMeetingName() {
    try {
      let response = await httpClient.get(`/api/meetings/group/name`, {
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      });

      this.setState({ meetingNameList: response.data });
    } catch (err) {}
  }

  async uploadExistingTemplate() {
    this.setState({ templateUploading: true });

    try {
      let response = await httpClient.post(
        `/api/meetings/${this.props.values.id}/documents/templates/copy`,
        {
          id: this.state.selectedTemplate.id,
          folderId: this.props.values.documentFolder,
        },
        {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        }
      );

      message.success("อัพโหลดไฟล์เรียบร้อยแล้ว");
      this.getMeetingDocuments(
        this.props.values.id,
        this.props.values.documentFolder
      );

      this.setState({
        fileUploadModalVisible: false,
        templateUploading: false,
      });
    } catch (e) {
      console.log(e);
    }
  }

  handleDateChange(value) {
    this.setState({ meetingDate: value });
    this.props.values.meetingDate = value;
  }

  handleFileChanged(file, type) {
    if (type === "1") {
      this.setState({ inviteDocument: file });
    } else if (type === "2") {
      this.setState({ meetingDocument: file });
    } else if (type === "3") {
      this.setState({ finalDocument: file });
    } else if (type === "4") {
      this.setState({ reportDocument: file });
    } else if (type === "5") {
      this.setState({ reportFinalDocument: file });
    }
  }

  openAgendaModal() {
    const agendas = JSON.parse(JSON.stringify(this.state.agendas));

    this.setState({
      updatedAgendas: agendas,
      agendaDetailModalVisible: true,
    });
  }

  handleAgendaChange(item, value, key) {
    const agendas = this.state.updatedAgendas;

    agendas.map((agenda) => {
      if (item.sequence === agenda.sequence) {
        agenda[key] = value;
      }
    });

    this.setState({ updatedAgendas: agendas });
  }

  renderAgendaForm() {
    return this.state.updatedAgendas.map((item, index) => {
      return (
        <Row form key={index}>
          <Col md="12" className="form-group">
            <div class="d-flex align-items-center">
              <label class="font-weight-bold flex-fill">
                ระเบียบวาระที่ {item.sequence}
              </label>
              {index >= 4 && (
                <div
                  className="pointer d-flex align-items-center font-12 text-muted"
                  onClick={() => this.removeAgenda(index)}
                >
                  <DeleteOutlined className="mr-1" />
                  <div style={{ marginTop: -2 }}>ลบ</div>
                </div>
              )}
            </div>
            <FormInput
              name={`agenda-title${index}`}
              id={`agenda-title${index}`}
              value={item.title}
              className="mb-2"
              onChange={(e) =>
                this.handleAgendaChange(item, e.target.value, "title")
              }
            />

            <div className="agenda-editor">
              {/* <FormTextarea
              rows="5"
              onChange={(e) => this.handleAgendaChange(item, e.target.value, 'body')}
            >

            </FormTextarea> */}
              {/* <ReactQuill 
              theme="snow" 
              value={item.body} 
              modules={{
                toolbar: false
              }}
              onChange={(value) => this.handleAgendaChange(item, value, 'body')}
            /> */}
            </div>
          </Col>
        </Row>
      );
    });
  }

  addAgenda() {
    const agendas = this.state.updatedAgendas;
    agendas.push({
      title: "",
      body: "",
      sequence: agendas.length + 1,
    });

    this.setState({ updatedAgendas: agendas });
  }

  removeAgenda(index) {
    const agendas = this.state.updatedAgendas;
    agendas.splice(index, 1);
    this.setState({ updatedAgendas: agendas });
  }

  async saveAgendas() {
    await this.setState({
      agendaDetailModalVisible: false,
      agendas: this.state.updatedAgendas,
    });
  }

  handleEmailChange(value, key) {
    const email = this.state.email;
    email[key] = value;

    this.setState({ email });
  }

  async handleEmailTagChange(value) {
    this.setState({ emailList: value });
  }

  renderDocumentIcon(name) {
    const fileType = name.split(".").pop();
    let fileIcon;

    if (fileType === "jpg" || fileType === "png") {
      fileIcon = require("assets/img/image.svg");
    } else if (fileType === "doc" || fileType === "docx") {
      fileIcon = require("assets/img/word.svg");
    } else if (fileType === "ppt" || fileType === "pptx") {
      fileIcon = require("assets/img/ppt.svg");
    } else if (
      fileType === "xls" ||
      fileType === "xlsx" ||
      fileType === "csv"
    ) {
      fileIcon = require("assets/img/excel.svg");
    } else if (fileType === "pdf") {
      fileIcon = require("assets/img/pdf.svg");
    } else {
      fileIcon = require("assets/img/document.svg");
    }

    return (
      <img className="mr-2" width="25" src={fileIcon} alt="Document Icon" />
    );
  }

  renderUploadFileList(files) {
    let fileList = [];

    if (files && files.length > 0) {
      fileList = files.map((file) => {
        const fileIcon = this.renderDocumentIcon(file.name);

        return (
          <div
            className="d-flex align-items-center py-3 px-4 rounded border mb-3"
            key={file.uid}
          >
            <div className="d-flex align-items-center flex-fill">
              {fileIcon}
              <div className="flex-fill">
                <div className="d-flex align-items-center">
                  <div className="flex-fill font-weight-bold">{file.name}</div>
                  {file.uploadProgress > 0 ? (
                    <div className="d-flex align-items-center">
                      {file.uploadProgress * 100 < 100 && (
                        <LoadingOutlined
                          style={{ fontSize: 16, color: "#1890ff" }}
                          spin
                        />
                      )}
                      <div class="font-12 text-muted ml-2">
                        {Math.round(file.uploadProgress * 100)}%
                      </div>
                    </div>
                  ) : null}
                </div>
                {file.uploadProgress > 0 ? (
                  <Progress
                    active="true"
                    strokeWidth={5}
                    percent={file.uploadProgress * 100}
                    showInfo={false}
                  />
                ) : (
                  <div className="text-muted font-12 mt-1">
                    {filesize(file.size)}
                  </div>
                )}
              </div>
            </div>
            <div className="pointer ml-3">
              <CloseCircleFilled style={{ fontSize: 24 }} />
            </div>
          </div>
        );
      });
    }

    return fileList;
  }

  setCreateDocumentMethod(value) {
    this.setState({ createDocumentMethod: value });
    this.props.values.createDocumentMethod = value;
  }

  setAttendeeListMethod(value) {
    let isValid = true;

    if (value === 2) {
      if (!this.state.isMeetingExist) {
        isValid = false;
        message.error("กรุณาใส่หัวข้อการประชุมครั้งก่อนให้ถูกต้อง");
      }
    }

    if (isValid) {
      this.setState({ attendeesMethod: value });
      this.props.values.attendeesMethod = value;
    }
  }

  async getMeetingDocuments(id, folderId) {
    await this.props.getMeetingDocuments(id, folderId);

    if (this.props.meetingReducer.documents) {
      let inviteDocument = this.props.meetingReducer.documents.filter(
        (item) => {
          return item.type === "1";
        }
      )[0];
      let meetingDocument = this.props.meetingReducer.documents.filter(
        (item) => {
          return item.type === "2";
        }
      )[0];
      let finalDocument = this.props.meetingReducer.documents.filter((item) => {
        return item.type === "3";
      })[0];
      let reportDocument = this.props.meetingReducer.documents.filter(
        (item) => {
          return item.type === "4";
        }
      )[0];
      let reportFinalDocument = this.props.meetingReducer.documents.filter(
        (item) => {
          return item.type === "5";
        }
      )[0];

      this.setState({
        inviteDocument,
        meetingDocument,
        finalDocument,
        reportDocument,
        reportFinalDocument,
      });
    }
  }

  openEmailModal(type) {
    let mailBody = "";
    let isDocumentReady = false;

    if (type === 3 && this.state.finalDocument) {
      isDocumentReady = true;

      mailBody = `
        &nbsp;&nbsp;&nbsp;&nbsp;ขอส่งเอกสารประกอบการ${
          this.props.values.title
        } ครั้งที่ ${this.props.values.sequence}/${
        this.props.values.year
      } ตามลิงค์ที่แนบ <a href="${domainName}/meeting/view/${
        this.props.values.id
      }">${domainName}/meeting/view/${this.props.values.id}</a>
        <p>${
          this.props.values.password
            ? "รหัสผ่านสำหรับเปิดเอกสารการประชุม: " + this.props.values.password
            : ""
        }</p>
      `;
    } else if (type === 5 && this.state.reportFinalDocument) {
      isDocumentReady = true;

      mailBody = `
        &nbsp;&nbsp;&nbsp;&nbsp;ขอส่งรายงานการ${
          this.props.values.title
        } ครั้งที่ ${this.props.values.sequence}/${
        this.props.values.year
      } ตามลิงค์ที่แนบ <a href="${domainName}/meeting/report/${
        this.props.values.id
      }">${domainName}/meeting/report/${
        this.props.values.id
      }</a> และโปรดแจ้งตอบตามแบบฟอร์ม ตามลิงค์ที่แบบ <a href="${domainName}/meeting/report/confirm/${
        this.props.values.id
      }">${domainName}/meeting/report/confirm/${this.props.values.id}</a>
        <p>${
          this.props.values.password
            ? "รหัสผ่านสำหรับเปิดเอกสารการประชุม: " + this.props.values.password
            : ""
        }</p>
      `;
    }

    if (isDocumentReady) {
      const email = {
        subject: "",
        body: mailBody,
      };

      this.setState({
        emailModalVisible: true,
        emailType: type,
        email,
      });
    } else {
      message.error("กรุณาอัพโหลดเอกสารก่อนทำการส่งอีเมล");
    }
  }

  async sendDocumentLink() {
    this.setState({ emailSending: true });

    await this.props.getMeetingAttendees(this.props.meetingReducer.result.id);

    let targetAttendees = [];

    if (this.state.isAllEmailSent) {
      targetAttendees = this.props.meetingReducer.attendees;
    } else {
      targetAttendees = this.props.meetingReducer.attendees.filter((item) => {
        for (const email of this.state.emailList) {
          if (email === item.email) {
            return item;
          }
        }
      });
    }

    for (const attendee of targetAttendees) {
      let mailBody = this.state.email.body;
      mailBody = mailBody.replace(
        `report/confirm/${this.props.values.id}`,
        `report/confirm/${this.props.values.id}?id=${attendee.id}`
      );

      const formData = new FormData();
      formData.append("subject", this.state.email.subject);
      formData.append("email", attendee.email);
      formData.append(
        "mailBody",
        `<p>เรียน ${attendee.name}</p>
        ${mailBody.replace(/\t/g, "\u00a0\u00a0\u00a0\u00a0")}
      `
      );

      const mailResponse = await httpClient.post(
        `/api/meetings/${this.props.meetingReducer.result.id}/mail/send`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
        }
      );
    }

    message.success("ส่งอีเมลเรียบร้อยแล้ว");
    this.setState({
      emailSending: false,
      emailModalVisible: false,
      emailList: [],
    });
  }

  async getComments() {
    try {
      const response = await httpClient.get(
        `api/meetings/${this.props.values.id}/comment`,
        {}
      );

      this.setState({
        comments: response.data.comments,
        commentGroups: response.data.groups,
      });
    } catch (err) {
      console.log(err);
    }
  }

  async getCommentByAttendee(comment) {
    const comments = this.state.comments.filter((item) => {
      return item.attendeeId === comment.attendeeId;
    });

    this.setState({
      commentModalVisible: true,
      commentName: comment.name,
      selectedComments: comments,
    });
  }

  async getMeetingAttachments(id, folderId) {
    await this.props.getMeetingAttachments(id, folderId);

    if (this.props.meetingReducer.attachments) {
      this.setState({ attachments: this.props.meetingReducer.attachments });
    }
  }

  async getTemplateFiles() {
    await this.props.getTemplateFiles();

    if (this.props.meetingReducer.templates) {
      this.setState({ templates: this.props.meetingReducer.templates });
    }
  }

  onTemplateChange(value) {
    if (this.state.templates) {
      this.state.templates.map((item) => {
        if (item.id === value) {
          this.setState({ selectedTemplate: item });
        }
      });
    }
  }

  handleStartTimeChange(value) {
    const startTime = value ? value.toDate() : null;
    this.props.values.meetingStart = startTime;
    this.setState({ startTime });
  }

  handleEndTimeChange(value) {
    const endTime = value ? value.toDate() : null;
    this.props.values.meetingEnd = endTime;
    this.setState({ endTime });
  }

  handlePasswordChange(value) {
    this.props.values.password = value;
    this.setState({ password: value });
  }

  renderDocumentType() {
    let typeLabel = "เอกสาร";

    if (this.state.documentType === 1) {
      typeLabel += "ระเบียบวาระการประชุม";
    } else if (this.state.documentType === 2) {
      typeLabel += "การประชุม";
    } else if (this.state.documentType === 4) {
      typeLabel += "มติการประชุม";
    }

    return typeLabel;
  }

  createMeetingDocument(type) {
    this.setState({
      fileUploadModalVisible: true,
      documentType: type,
    });
  }

  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.getSuggestions(value),
    });
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: this.state.meetings,
    });
  };

  onSuggestionSelected = (
    event,
    { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }
  ) => {
    this.props.values.title = suggestion.title;
    this.props.values.lastMeetingId = suggestion.id;

    this.setState({
      isMeetingExist: true,
    });
  };

  getSuggestions = (value) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    const result = this.state.meetingNameList.filter((meeting) =>
      inputLength !== 0
        ? meeting.title.toLowerCase().includes(inputValue)
        : true
    );

    this.setState({
      isMeetingExist: false,
      attendeesMethod: 1,
    });

    if (inputLength === 0) {
      this.props.values.title = "";
    }

    return result;
  };

  renderSuggestion = (suggestion) => suggestion.title;

  shouldRenderSuggestions() {
    return true;
  }

  getSuggestionValue = (suggestion) => suggestion.title;

  onMeetingNameChange = (event, { newValue }) => {
    this.props.values.title = newValue;
  };

  render() {
    const {
      values,
      handleChange,
      isDisableField,
      handleBlur,
      setFieldValue,
      errors,
      touched,
    } = this.props;

    const { uploading, fileList } = this.state;
    const props = {
      onRemove: (file) => {
        this.setState((state) => {
          const index = state.fileList.indexOf(file);
          const newFileList = state.fileList.slice();
          newFileList.splice(index, 1);
          return {
            fileList: newFileList,
          };
        });
      },
      beforeUpload: (file) => {
        this.setState((state) => ({
          fileList: [...state.fileList, file],
        }));
        return false;
      },
      fileList,
    };

    this.props.values.agendas = this.state.agendas;

    const { suggestions } = this.state;

    const inputProps = {
      placeholder: "พิมพ์ชื่อการประชุม",
      value: values.title,
      onChange: this.onMeetingNameChange,
      disabled: values.editable === "N" ? true : false,
    };

    return (
      <React.Fragment>
        <Tabs defaultActiveKey="1">
          <TabPane tab="ข้อมูลการประชุม" key="1">
            <fieldset disabled={isDisableField} className="mt-3">
              <Row form>
                <Col md="10" className="form-group">
                  <label>
                    หัวข้อการประชุม<span className="text-danger">*</span>
                  </label>
                  <Autosuggest
                    name="title"
                    id="title"
                    suggestions={suggestions}
                    onSuggestionsFetchRequested={
                      this.onSuggestionsFetchRequested
                    }
                    onSuggestionsClearRequested={
                      this.onSuggestionsClearRequested
                    }
                    shouldRenderSuggestions={this.shouldRenderSuggestions}
                    onSuggestionSelected={this.onSuggestionSelected}
                    getSuggestionValue={this.getSuggestionValue}
                    renderSuggestion={this.renderSuggestion}
                    inputProps={inputProps}
                    disabled={values.editable === "N" ? true : false}
                  />
                  {errors.title && touched.title && (
                    <div className="font-12 text-danger mt-1">
                      {errors.title}
                    </div>
                  )}
                </Col>
                <Col md="2">
                  <label>
                    ครั้งที่<span className="text-danger">*</span>
                  </label>
                  <NumberFormat
                    customInput={FormInput}
                    thousandSeparator={true}
                    inputMode="numeric"
                    name="sequence"
                    id="sequence"
                    onChange={handleChange}
                    value={values.sequence}
                    disabled={values.editable === "N" ? true : false}
                  />
                  {errors.sequence && touched.sequence && (
                    <div className="font-12 text-danger mt-1">
                      {errors.sequence}
                    </div>
                  )}
                </Col>
              </Row>

              <Row form>
                <Col md="4" className="form-group">
                  <label>
                    วันที่ประชุม<span className="text-danger">*</span>
                  </label>

                  <MuiPickersUtilsProvider utils={MomentUtils} locale={"th"}>
                    <DatePicker
                      label=""
                      format="D MMM YYYY"
                      value={this.state.meetingDate}
                      yearOffset={543}
                      className="d-flex"
                      name="meetingDate"
                      id="meetingDate"
                      autoOk={true}
                      disabled={values.editable === "N" ? true : false}
                      onChange={(value) =>
                        this.handleDateChange(value ? value.toDate() : null)
                      }
                    />
                  </MuiPickersUtilsProvider>

                  {errors.meetingDate && touched.meetingDate && (
                    <div className="font-12 text-danger mt-1">
                      {errors.meetingDate}
                    </div>
                  )}
                </Col>
                <Col md="4">
                  <label>
                    เวลาเริ่มประชุม<span className="text-danger">*</span>
                  </label>
                  <TimePicker
                    defaultValue={moment(this.props.values.meetingStart)}
                    showSecond={false}
                    format={"HH:mm"}
                    className="time-picker-block"
                    minuteStep={5}
                    name="meetingStart"
                    id="meetingStart"
                    disabled={values.editable === "N" ? true : false}
                    onChange={this.handleStartTimeChange}
                  />

                  {errors.meetingStart && touched.meetingStart && (
                    <div className="font-12 text-danger mt-1">
                      {errors.meetingStart}
                    </div>
                  )}
                </Col>
                <Col md="4">
                  <label>
                    เวลาสิ้นสุดประชุม<span className="text-danger">*</span>
                  </label>
                  <TimePicker
                    defaultValue={moment(this.props.values.meetingEnd)}
                    showSecond={false}
                    format={"HH:mm"}
                    className="time-picker-block"
                    minuteStep={5}
                    name="meetingEnd"
                    id="meetingEnd"
                    disabled={values.editable === "N" ? true : false}
                    onChange={this.handleEndTimeChange}
                  />

                  {errors.meetingEnd && touched.meetingEnd && (
                    <div className="font-12 text-danger mt-1">
                      {errors.meetingEnd}
                    </div>
                  )}
                </Col>
              </Row>

              <Row form>
                <Col md="4">
                  <FormGroup>
                    <label>
                      สถานที่ประชุม<span className="text-danger">*</span>
                    </label>
                    <FormSelect
                      name="location"
                      id="location"
                      onChange={handleChange}
                      value={values.location}
                      disabled={values.editable === "N" ? true : false}
                    >
                      <option value=""></option>
                      {this.state.locations.map((location) => {
                        return (
                          <option value={location.id} key={location.id}>
                            {location.name}
                          </option>
                        );
                      })}
                    </FormSelect>
                    {errors.location && touched.location && (
                      <div className="font-12 text-danger mt-1">
                        {errors.location}
                      </div>
                    )}
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup>
                    <label>
                      อาคาร<span className="text-danger">*</span>
                    </label>
                    <FormSelect
                      name="building"
                      id="building"
                      onChange={handleChange}
                      value={values.building}
                      disabled={values.editable === "N" ? true : false}
                    >
                      <option value=""></option>
                      {this.state.buildings.map((building) => {
                        return (
                          <option value={building.id} key={building.id}>
                            {building.name}
                          </option>
                        );
                      })}
                    </FormSelect>
                    {errors.building && touched.building && (
                      <div className="font-12 text-danger mt-1">
                        {errors.building}
                      </div>
                    )}
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup>
                    <label>
                      ห้อง<span className="text-danger">*</span>
                    </label>
                    <FormSelect
                      name="room"
                      id="room"
                      onChange={handleChange}
                      value={values.room}
                      disabled={values.editable === "N" ? true : false}
                    >
                      <option value=""></option>
                      {this.state.rooms.map((room) => {
                        return (
                          <option value={room.id} key={room.id}>
                            {room.name}
                          </option>
                        );
                      })}
                    </FormSelect>
                    {errors.room && touched.room && (
                      <div className="font-12 text-danger mt-1">
                        {errors.room}
                      </div>
                    )}
                  </FormGroup>
                </Col>
              </Row>

              {!values.id && (
                <React.Fragment>
                  <div className="row">
                    <div className="col-lg-6">
                      <h5 className="mt-4 font-weight-bold">
                        รายชื่อผู้เข้าประชุม
                      </h5>
                      <div className="d-flex mt-3">
                        <div
                          className={
                            "file-upload-type-item mr-3 " +
                            (this.state.attendeesMethod === 1 ? "active" : "")
                          }
                          onClick={() => this.setAttendeeListMethod(1)}
                        >
                          <img
                            width="50"
                            src={require("assets/img/find-user.svg")}
                          />
                          <p className="mt-3 mb-0 font-weight-bold">
                            แบบกำหนดเอง
                          </p>
                          <p className="font-12 text-muted mt-2 mb-0">
                            เพิ่มรายชื่อด้วยตนเอง
                            <br />
                            หลังจากสร้างการประชุม
                          </p>
                        </div>
                        <div
                          className={
                            "file-upload-type-item mr-3 " +
                            (this.state.attendeesMethod === 2 ? "active" : "")
                          }
                          onClick={() => this.setAttendeeListMethod(2)}
                        >
                          <img
                            width="50"
                            src={require("assets/img/users.svg")}
                          />
                          <p className="mt-3 mb-0 font-weight-bold">
                            แบบอัตโนมัติ
                          </p>
                          <p className="font-12 text-muted mt-2 mb-0">
                            เพิ่มรายชื่อผู้เข้าประขุม
                            <br />
                            จากการประชุมครั้งที่ผ่านมา
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <h5 className="mt-4 font-weight-bold">
                        เอกสารระเบียบวาระการประชุม
                      </h5>

                      <div className="d-flex mt-3">
                        <div
                          className={
                            "file-upload-type-item mr-3 " +
                            (this.state.createDocumentMethod === 1
                              ? "active"
                              : "")
                          }
                          onClick={() => this.setCreateDocumentMethod(1)}
                        >
                          <img
                            width="50"
                            src={require("assets/img/folder-create.svg")}
                          />
                          <p className="mt-3 mb-0 font-weight-bold">
                            สร้างเอกสารใหม่
                          </p>
                          <p className="font-12 text-muted mt-2 mb-0">
                            สร้างเอกสารจากข้อมูล
                            <br />
                            การประชุมที่กรอกในระบบ
                          </p>
                        </div>
                        <div
                          className={
                            "file-upload-type-item mr-3 " +
                            (this.state.createDocumentMethod === 2
                              ? "active"
                              : "")
                          }
                          onClick={() => this.setCreateDocumentMethod(2)}
                        >
                          <img
                            width="50"
                            src={require("assets/img/folder-upload.svg")}
                          />
                          <p className="mt-3 mb-0 font-weight-bold">
                            อัพโหลดเอกสาร
                          </p>
                          <p className="font-12 text-muted mt-2 mb-0">
                            เลือกเอกสารจากคอมพิวเตอร์
                            <br />
                            หรืออุปกรณ์ของคุณ
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {this.state.createDocumentMethod === 1 && (
                    <React.Fragment>
                      <div className="d-flex align-items-center mb-3 mt-5">
                        <div className="flex-fill mr-3">
                          <h5 className="font-weight-bold mb-1">
                            ระเบียบวาระการประชุม
                          </h5>
                          <p className="text-muted mb-0">
                            ใช้ในการสร้างเอกสารผ่านระบบเท่านั้น
                            (ไม่จำเป็นต้องกรอกข้อมูลหากเลือกอัพโหลดเอกสารจากคอมพิวเตอร์หรืออุปกรณ์ของคุณ)
                          </p>
                        </div>
                        <Button
                          type="primary"
                          htmlType="button"
                          onClick={() => this.openAgendaModal()}
                        >
                          แก้ไขวาระ
                        </Button>
                      </div>

                      {this.state.agendas.map((item) => {
                        return (
                          <div
                            className="border rounded mb-3"
                            key={item.sequence}
                          >
                            <div className="py-3 px-4">
                              <label className="font-weight-bold mb-0">
                                ระเบียบวาระที่ {item.sequence}:
                                <span className="ml-2">{item.title}</span>
                              </label>

                              {item.body && (
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: item.body,
                                  }}
                                  className="mt-3 agenda-html-value"
                                ></div>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </React.Fragment>
                  )}

                  {this.state.createDocumentMethod === 2 && (
                    <React.Fragment>
                      <h5 className="font-weight-bold mb-1 mt-5">
                        อัพโหลดเอกสาร
                      </h5>
                      <p className="text-muted mb-0">
                        สามารถอัพโหลดเอกสารในภายหลังได้
                      </p>

                      {this.state.inviteDocument ? (
                        <div className="mt-4">
                          <div className="d-flex align-items-center py-3 px-4 rounded border mb-3">
                            <div className="d-flex align-items-center flex-fill">
                              {this.renderDocumentIcon(
                                this.state.inviteDocument.name
                              )}
                              <div className="flex-fill">
                                <div className="d-flex align-items-center">
                                  <div className="flex-fill font-weight-bold">
                                    {this.state.inviteDocument.name}
                                  </div>
                                </div>
                                <div className="text-muted font-12 mt-1">
                                  {filesize(this.state.inviteDocument.size)}
                                </div>
                              </div>
                            </div>
                            <div className="pointer ml-3">
                              <CloseCircleFilled
                                onClick={() =>
                                  this.setState({ inviteDocument: "" })
                                }
                                style={{ fontSize: 24 }}
                              />
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="border rounded mt-4 mb-3">
                          <div className="py-3 px-4 d-flex align-items-center">
                            <div className="d-flex align-items-center flex-fill">
                              <div className="d-flex align-items-center mr-3">
                                <img
                                  width="50"
                                  src={require("assets/img/word.svg")}
                                />
                              </div>

                              <div>
                                <div className="font-weight-bold">
                                  ยังไม่มีเอกสาร
                                </div>
                                <div className="text-muted font-12 mt-1 d-flex align-items-center">
                                  Microsoft Word (.doc, .docx)
                                </div>
                              </div>
                            </div>
                            <div>
                              <Upload {...this.uploadAgendaProps}>
                                <Button
                                  type="primary"
                                  className="d-flex align-items-center"
                                >
                                  <UploadOutlined style={{ color: "#fff" }} />{" "}
                                  เลือกเอกสาร
                                </Button>
                              </Upload>
                            </div>
                          </div>
                        </div>
                      )}
                    </React.Fragment>
                  )}
                </React.Fragment>
              )}

              {values.id && (
                <React.Fragment>
                  <Row form>
                    <Col md="12" className="form-group">
                      <h6 className="mt-2 mb-0 font-weight-bold">
                        รหัสผ่านสำหรับเปิดเอกสารการประชุม
                      </h6>
                      <p className="text-muted mb-3">
                        เมื่อทำการตั้งรหัสผ่าน
                        ผู้เข้าประชุมทุกท่านจะต้องทำการกรอกรหัสผ่านก่อนเปิดเอกสารการประชุม
                        โดยรหัสผ่านนี้จะถูกส่งผ่านทางอีเมลไปพร้อมกับลิงก์เอกสารการประชุม
                      </p>
                      <FormGroup>
                        <Input.Password
                          value={this.state.password}
                          onChange={(e) =>
                            this.handlePasswordChange(e.target.value)
                          }
                          name="password"
                          id="password"
                          disabled={values.editable === "N" ? true : false}
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <section>
                    <div className="d-flex align-items-center">
                      <div className="flex-fill">
                        <div className="d-flex align-items-center mb-2 pb-1">
                          <h6 className="m-0 font-weight-bold mr-2 flex-fill">
                            1. เอกสารระเบียบวาระการประชุม
                          </h6>
                        </div>
                      </div>
                    </div>

                    <FileItem
                      meeting={this.props.values}
                      microsoftAccounts={this.state.microsoftAccounts}
                      file={this.state.inviteDocument}
                      loading={this.state.documentLoading}
                      format="docx"
                      type="1"
                      onFileUpdated={this.handleFileChanged}
                    />
                  </section>

                  <section className="mt-5">
                    <div className="d-flex align-items-center">
                      <div className="flex-fill">
                        <div className="d-flex align-items-center mb-2 pb-1">
                          <h6 className="m-0 font-weight-bold mr-2 flex-fill">
                            2. จัดทำเอกสารประกอบการประชุม
                          </h6>
                        </div>
                      </div>
                    </div>

                    <FileItem
                      meeting={this.props.values}
                      microsoftAccounts={this.state.microsoftAccounts}
                      file={this.state.meetingDocument}
                      loading={this.state.documentLoading}
                      format="docx"
                      type="2"
                      onFileUpdated={this.handleFileChanged}
                    />
                  </section>

                  <section className="mt-5">
                    <div className="d-flex align-items-center">
                      <div className="flex-fill">
                        <div className="d-flex align-items-center mb-2 pb-1">
                          <h6 className="m-0 font-weight-bold mr-2 flex-fill">
                            3. เอกสารประกอบการประชุม
                          </h6>
                        </div>
                      </div>
                    </div>

                    <FileItem
                      meeting={this.props.values}
                      file={this.state.finalDocument}
                      loading={this.state.documentLoading}
                      format="pdf"
                      type="3"
                      onFileUpdated={this.handleFileChanged}
                    />

                    <Descriptions
                      bordered
                      size="small"
                      column={1}
                      className="mt-3"
                    >
                      <Descriptions.Item label="ลิงก์สำหรับผู้เข้าประชุม">
                        <div className="d-flex align-items-center">
                          <div className="flex-fill mr-3">
                            {this.state.finalDocument
                              ? `${domainName}/meeting/view/${this.props.values.id}`
                              : "ลิงก์จะแสดงเมื่ออัพโหลดเอกสาร Pdf สำหรับผู้เข้าประชุม"}
                          </div>
                          <Button onClick={() => this.openEmailModal(3)}>
                            ส่งอีเมล
                          </Button>
                        </div>
                      </Descriptions.Item>
                    </Descriptions>
                  </section>

                  <section className="mt-5">
                    <div className="d-flex align-items-center">
                      <div className="flex-fill">
                        <div className="d-flex align-items-center mb-2 pb-1">
                          <h6 className="m-0 font-weight-bold mr-2 flex-fill">
                            4. จัดทำรายงานการประชุม
                          </h6>
                        </div>
                      </div>
                    </div>

                    <FileItem
                      meeting={this.props.values}
                      microsoftAccounts={this.state.microsoftAccounts}
                      file={this.state.reportDocument}
                      loading={this.state.documentLoading}
                      format="docx"
                      type="4"
                      onFileUpdated={this.handleFileChanged}
                    />
                  </section>

                  <section className="mt-5">
                    <div className="d-flex align-items-center">
                      <div className="flex-fill">
                        <div className="d-flex align-items-center mb-2 pb-1">
                          <h6 className="m-0 font-weight-bold mr-2 flex-fill">
                            5. รายงานการประชุม
                          </h6>
                        </div>
                      </div>
                    </div>

                    <FileItem
                      meeting={this.props.values}
                      file={this.state.reportFinalDocument}
                      loading={this.state.documentLoading}
                      format="pdf"
                      type="5"
                      onFileUpdated={this.handleFileChanged}
                    />

                    <Descriptions
                      bordered
                      size="small"
                      column={1}
                      className="mt-3"
                    >
                      <Descriptions.Item label="ลิงก์รายงานการประชุม">
                        <div className="d-flex align-items-center">
                          <div className="flex-fill mr-3">
                            {this.state.reportFinalDocument
                              ? decodeURI(
                                  `${domainName}/meeting/report/${this.props.values.id}`
                                )
                              : "ลิงก์จะแสดงเมื่ออัพโหลดเอกสารรายงานการประชุม"}
                          </div>
                          <Button onClick={() => this.openEmailModal(5)}>
                            ส่งอีเมล
                          </Button>
                        </div>
                      </Descriptions.Item>
                      <Descriptions.Item label="ลิงก์แบบตอบรับรายงานการประชุม">
                        <div className="d-flex align-items-center">
                          <div className="flex-fill mr-3">
                            {this.state.reportFinalDocument
                              ? decodeURI(
                                  `${domainName}/meeting/report/confirm/${this.props.values.id}`
                                )
                              : "ลิงก์จะแสดงเมื่ออัพโหลดเอกสารรายงานการประชุม"}
                          </div>
                        </div>
                      </Descriptions.Item>
                    </Descriptions>
                  </section>
                </React.Fragment>
              )}
            </fieldset>
          </TabPane>
          {this.props.values.id && (
            <React.Fragment>
              <TabPane tab="เชิญประชุม" key="2">
                <MeetingEvent meeting={this.props.values} />
              </TabPane>
              <TabPane tab="ประเด็นอภิปราย" key="3">
                <h5 className="mt-2 mb-3 font-weight-bold flex-fill">
                  ประเด็นอภิปราย
                </h5>

                <Row className="comment-descriptions">
                  <Col md="12">
                    {this.state.commentGroups.length > 0 ? (
                      <Descriptions bordered size="small" column={2}>
                        {this.state.commentGroups.map((item) => {
                          return (
                            <React.Fragment>
                              <Descriptions.Item label="ชื่อผู้เข้าประชุม">
                                <div className="text-center">{item.name}</div>
                              </Descriptions.Item>
                              <Descriptions.Item label="จำนวนมติ">
                                <div className="d-flex align-items-center">
                                  <div className="flex-fill ml-3">
                                    {item.total}
                                  </div>
                                  <Button
                                    htmlType="button"
                                    onClick={() =>
                                      this.getCommentByAttendee(item)
                                    }
                                    style={{
                                      width: 100,
                                      alignSelf: "flex-end",
                                    }}
                                  >
                                    อ่าน
                                  </Button>
                                </div>
                              </Descriptions.Item>
                            </React.Fragment>
                          );
                        })}
                      </Descriptions>
                    ) : (
                      <div className="p-4 border rounded">
                        <Empty description="ไม่มีข้อมูล" />
                      </div>
                    )}
                  </Col>
                </Row>
              </TabPane>
              <TabPane tab="รับรองรายงานการประชุม" key="4">
                <MeetingReportResponse meeting={this.props.values} />
              </TabPane>
            </React.Fragment>
          )}
        </Tabs>

        <Modal
          title={null}
          width={650}
          footer={null}
          closable={false}
          visible={this.state.agendaDetailModalVisible}
          onCancel={() => this.setState({ agendaDetailModalVisible: false })}
          style={{ top: 20 }}
        >
          <div className="d-flex align-items-center mb-3">
            <div className="flex-fill">
              <h5 class="font-weight-bold mb-1">ระเบียบวาระการประชุม</h5>
              <p class="text-muted mb-0">
                กรอกรายละเอียดวาระการประชุมเพื่อใช้ในการสร้างเอกสาร
              </p>
            </div>
            <Button
              type="primary"
              htmlType="button"
              onClick={() => this.addAgenda()}
            >
              เพิ่มวาระ
            </Button>
          </div>

          <hr className="mt-1 mb-4" style={{ borderStyle: "dashed" }} />

          {this.renderAgendaForm()}

          <div className="text-center mt-4">
            <Button
              type="primary"
              htmlType="button"
              className="mr-2"
              onClick={() => this.saveAgendas()}
            >
              ตกลง
            </Button>
            <Button
              htmlType="button"
              onClick={() => this.setState({ agendaDetailModalVisible: false })}
            >
              ยกเลิก
            </Button>
          </div>
        </Modal>

        <Modal
          title={`ประเด็นอภิปรายจาก ${this.state.commentName}`}
          width={650}
          footer={null}
          closable={false}
          visible={this.state.commentModalVisible}
          onCancel={() => this.setState({ commentModalVisible: false })}
          style={{ top: 20 }}
        >
          {this.state.selectedComments &&
            this.state.selectedComments.map((item) => {
              return (
                <div className="mb-4 pb-2">
                  <div className="text-muted">วาระที่ {item.agenda}</div>
                  <p className="mt-2 mb-0">{item.description}</p>
                </div>
              );
            })}
        </Modal>

        <Modal
          title="ส่งอีเมล"
          width={800}
          visible={this.state.emailModalVisible}
          closable={true}
          maskClosable={false}
          onCancel={() => this.setState({ emailModalVisible: false })}
          style={{ top: 20 }}
          footer={
            <div className="text-right">
              <Button
                type="primary"
                htmlType="button"
                className="mr-2"
                loading={this.state.emailSending}
                style={{ width: 100 }}
                onClick={() => {
                  const _this = this;
                  Modal.confirm({
                    title: <div>ยืนยันการส่งอีเมลให้ผู้เข้าประชุม</div>,
                    okText: "ส่งอีเมล",
                    cancelText: "ยกเลิก",
                    maskClosable: true,
                    onOk() {
                      _this.sendDocumentLink();
                    },
                  });
                }}
              >
                ส่งอีเมล
              </Button>
              <Button
                htmlType="button"
                disabled={this.state.emailSending}
                style={{ width: 100 }}
                onClick={() => this.setState({ emailModalVisible: false })}
              >
                ยกเลิก
              </Button>
            </div>
          }
        >
          <Spin
            spinning={this.state.emailSending}
            indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
          >
            <Row form>
              <Col md="12" className="form-group">
                <label>ผู้เข้าประชุม</label>
                <Select
                  mode="multiple"
                  allowClear
                  style={{ width: "100%" }}
                  placeholder="เลือกอีเมลผู้้เข้าประชุม"
                  disabled={this.state.isAllEmailSent}
                  onChange={this.handleEmailTagChange}
                >
                  {this.props.meetingReducer.attendees &&
                    this.props.meetingReducer.attendees.map((item) => {
                      return <Option key={item.email}>{item.email}</Option>;
                    })}
                </Select>

                <Checkbox
                  checked={this.state.isAllEmailSent}
                  onChange={(e) =>
                    this.setState({ isAllEmailSent: e.target.value })
                  }
                  className="mt-2"
                >
                  ส่งอีเมลถึงผู้เข้าประชุมทุกคน
                </Checkbox>
              </Col>
            </Row>

            <Row form>
              <Col md="12" className="form-group">
                <label>หัวข้อ</label>
                <FormInput
                  name="emailSubject"
                  id="emailSubject"
                  placeholder="หัวข้ออีเมล"
                  onChange={(e) =>
                    this.handleEmailChange(e.target.value, "subject")
                  }
                  value={this.state.email.subject}
                />
              </Col>
            </Row>

            <Row form>
              <Col md="12" className="form-group">
                <div>อีเมล</div>
                <div className="mail-editor mt-2">
                  <ReactQuill
                    theme="snow"
                    value={this.state.email.body}
                    modules={{
                      toolbar: [
                        ["bold", "italic", "underline"],
                        [{ indent: "-1" }, { indent: "+1" }],
                        [
                          { align: null },
                          { align: "center" },
                          { align: "right" },
                        ],
                        ["link"],
                      ],
                    }}
                    onChange={(value) => this.handleEmailChange(value, "body")}
                  />
                </div>
              </Col>
            </Row>
          </Spin>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({
  meetingReducer,
  buildingsReducer,
  locationsReducer,
  roomsReducer,
  groupNamesReducer,
}) => ({
  meetingReducer,
  buildingsReducer,
  locationsReducer,
  roomsReducer,
  groupNamesReducer,
});

const mapDispatchToProps = {
  ...actions,
  getAllBuildings,
  getAllLocations,
  getAllRooms,
  getGroupName,
};

export default connect(mapStateToProps, mapDispatchToProps)(MeetingForm);
